import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20251210-kursgebuehr",
        datum: "10.12.2025",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Kursgebühr mit Gültigkeitsdauer",
        lizenz: [LizenzEnum.KURSE],
        content: [
            "Passend zu den neuen Pauschgebühren der UVTs kann nun für jede Kursgebühr ein Gültigkeitszeitraum hinterlegt werden."
            + " So lassen sich die Gebührenänderungen zum Jahreswechsel ganz bequem abbilden."
        ],
        aktions: [
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/2025/12/kursgebuehr-mit-gueltigkeitsdauer/",
            },
        ],
    },
];

export {
    insights,
};
